/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualMaterialDto } from '../../models/backend-actual-material-dto';

export interface MonitoringActualsMaterialsCopyCreate$Params {
  id: number;
}

export function monitoringActualsMaterialsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsMaterialsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsMaterialsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualMaterialDto>;
    }),
  );
}

monitoringActualsMaterialsCopyCreate.PATH = '/api/monitoring/actuals/materials/copy/{id}/';
